import { GetShopList , SetRemindSwitch } from '@/api/ShopSwitch';

const state = {
    GetShopList : {},
};

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  },
  SET_SWITCH: (state, {key,data}) => {
    console.log(key)
    let data_list = JSON.parse(JSON.stringify(state.GetShopList))
    data_list.list[key].close_remind = data
    state['GetShopList'] = data_list;
  },
};
const actions = {
  GetShopList({ commit },data) { // 刷新token
    return new Promise((resolve)=>{
      GetShopList(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'GetShopList',data:newData});
        } catch (error) {
          console.log(error)  
        }
        resolve( res.data )
      });
    })
  },
  SetRemindSwitch({ commit },data) { // 刷新token
    return new Promise((resolve)=>{
      SetRemindSwitch(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'SetRemindSwitch',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve( res.data )
      });
    })
  },
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
